import { AppContextProvider } from "./providers";
import { BaseLayout } from "@/components/layout/BaseLayout";
import { Certificates, Datasheets, Home, IsometricDrawing, Procedures, Settings } from "@/features";
import { createRoutesFromElements, Route } from "react-router-dom";
import { DatabaseCheck, LoginCheck } from "@/components/guards";
import { lazy, Suspense } from "react";
import { Login, Logout, ResetPassword, ScanBadge, ScanBadgeManual } from "@/features/login";
import { NotFound } from "@/components";
import { RoleBasedInterface } from "@/features/rbi";

const Williams = lazy(() => import("@/features/custom/williams"));

export const routes = createRoutesFromElements(
  <Route element={<AppContextProvider />}>
    <Route element={<DatabaseCheck />}>
      <Route element={<BaseLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/login/scan" element={<ScanBadge />} />
        <Route path="/login/scan/manual" element={<ScanBadgeManual />} />
        <Route path="/login/reset" element={<ResetPassword />} />
        <Route path="/logout" element={<Logout />} />

        <Route element={<LoginCheck />}>
          <Route path="/" element={<Home />} />
          <Route path="/certificates" element={<Certificates />} />
          <Route path="/procedures" element={<Procedures />} />
          <Route path="/datasheets" element={<Datasheets />} />
          <Route path="/rbi/*" element={<RoleBasedInterface />} />
          <Route path="/drawing/:id" element={<IsometricDrawing />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/williams/*" element={<Suspense children={<Williams />} />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Route>
    </Route>
  </Route>
);
